// import React, { useState, useEffect } from "react";
// import {
//   Card,
//   Descriptions,
//   Tag,
//   Button,
//   Space,
//   Typography,
//   Divider,
//   Statistic,
//   Row,
//   Col,
// } from "antd";
// import {
//   ArrowLeftOutlined,
//   EditOutlined,
//   CalendarOutlined,
//   ClockCircleOutlined,
//   TagOutlined,
//   EuroOutlined,
//   DollarOutlined,
//   PercentageOutlined,
//   CheckCircleOutlined,
//   CloseCircleOutlined,
// } from "@ant-design/icons";
// import { useNavigate, useParams } from "react-router-dom";
// import { useDynamicApi } from "../../hooks/useApi";
// import { API_ENDPOINTS } from "../../config/api";
// import Toast from "../../utils/toast";
// import { useTranslation } from "react-i18next";

// const { Title, Text } = Typography;

// const SubscriptionPriceDetails = () => {
//   const { t, i18n } = useTranslation();
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [packageData, setPackageData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // API hooks
//   const { execute: getPackage, loading: packageLoading } = useDynamicApi("GET");

//   // Options as per FRS and your model
//   const PACKAGE_TYPE_OPTIONS = [
//     {
//       value: "INDIVIDUAL",
//       label: t("priceManager.packageTypeIndividual"),
//       color: "blue",
//     },
//     { value: "CLUB", label: t("priceManager.packageTypeClub"), color: "green" },
//     {
//       value: "KNKV",
//       label: t("priceManager.packageTypeKNKV"),
//       color: "purple",
//     },
//   ];

//   const DURATION_OPTIONS = [
//     { value: "MONTHLY", label: t("priceManager.durationMonthly") },
//     { value: "QUARTERLY", label: t("priceManager.durationQuarterly") },
//     { value: "YEARLY", label: t("priceManager.durationYearly") },
//     { value: "SEASONAL", label: t("priceManager.durationSeasonal") },
//   ];

//   const CURRENCY_SYMBOLS = {
//     EUR: "€",
//     USD: "$",
//     INR: "₹",
//   };

//   // Load package details
//   const loadPackageDetails = async () => {
//     setLoading(true);
//     try {
//       const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${id}`;
//       const response = await getPackage(endpoint);

//       if (response?.status === true && response.data) {
//         setPackageData(response.data);
//       } else {
//         Toast.error(t("priceManager.failedFetchDetails"));
//         navigate("/subscriptionprice");
//       }
//     } catch (error) {
//       console.error("Error fetching package details:", error);
//       Toast.error(error.message || t("priceManager.failedFetchDetails"));
//       navigate("/subscriptionprice");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (id) {
//       loadPackageDetails();
//     }
//   }, [id]);

//   // Format date
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//   };

//   // Format currency
//   const formatCurrency = (amount, currency) => {
//     if (!amount || isNaN(amount)) return "N/A";
//     const symbol = CURRENCY_SYMBOLS[currency] || currency;
//     return `${symbol}${parseFloat(amount).toFixed(2)}`;
//   };

//   // Get package type info
//   const getPackageTypeInfo = (type) => {
//     const found = PACKAGE_TYPE_OPTIONS.find((opt) => opt.value === type);
//     return found || { label: type, color: "default" };
//   };

//   // Get duration label
//   const getDurationLabel = (duration) => {
//     const option = DURATION_OPTIONS.find((opt) => opt.value === duration);
//     return option ? option.label : duration;
//   };

//   // Check if price is effective
//   const isPriceEffective = (item) => {
//     if (!item?.effective_start && !item?.effective_end) {
//       return true;
//     }

//     const today = new Date();
//     const startDate = item.effective_start
//       ? new Date(item.effective_start)
//       : null;
//     const endDate = item.effective_end ? new Date(item.effective_end) : null;

//     if (startDate && today < startDate) return false;
//     if (endDate && today > endDate) return false;

//     return true;
//   };

//   // Calculate discount percentage
//   const getDiscountPercentage = () => {
//     if (!packageData?.discounted_price || !packageData?.base_price) return null;
//     const base = parseFloat(packageData.base_price);
//     const discounted = parseFloat(packageData.discounted_price);
//     if (base <= 0) return null;
//     const discount = ((base - discounted) / base) * 100;
//     return Math.round(discount);
//   };

//   if (loading || packageLoading) return null;

//   if (!packageData) {
//     return (
//       <Card>
//         <div style={{ textAlign: "center", padding: "40px" }}>
//           <Title level={3}>{t("priceManager.noPricesFound")}</Title>
//           <Button type="primary" onClick={() => navigate("/subscriptionprice")}>
//             {t("common.previous")} {t("priceManager.packages")}
//           </Button>
//         </div>
//       </Card>
//     );
//   }

//   const packageTypeInfo = getPackageTypeInfo(packageData.package_type);
//   const discountPercentage = getDiscountPercentage();
//   const effective = isPriceEffective(packageData);
//   const currencySymbol =
//     CURRENCY_SYMBOLS[packageData.currency] || packageData.currency;

//   return (
//     <div className="package-details-page">
//       {/* Header with back button and actions */}
//       <div
//         style={{
//           marginBottom: "20px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Space>
//           <Button
//             icon={<ArrowLeftOutlined />}
//             onClick={() => navigate("/subscriptionprice")}
//           >
//             {t("common.previous")} {t("priceManager.packages")}
//           </Button>
//           <Title level={4} style={{ margin: 0 }}>
//             {t("priceManager.details")}
//           </Title>
//         </Space>
//         {/* Edit button commented out like in other detail pages */}
//         {/* <Button
//           type="primary"
//           icon={<EditOutlined />}
//           onClick={() => navigate(`/subscription-prices/edit/${packageData.id}`)}
//         >
//           Edit Package
//         </Button> */}
//       </div>

//       {/* Main Content */}
//       <Card>
//         {/* Avatar and Title Section */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             marginBottom: "24px",
//           }}
//         >
//           <div>
//             <h1 style={{ margin: 0, marginBottom: "8px" }}>
//               {packageData.name}
//             </h1>
//             <Space size="middle" wrap>
//               <Tag color={packageTypeInfo.color}>{packageTypeInfo.label}</Tag>
//               <Tag color={packageData.is_active ? "green" : "default"}>
//                 {packageData.is_active
//                   ? t("common.active")
//                   : t("common.inactive")}
//               </Tag>
//               {effective ? (
//                 <Tag color="green">{t("priceManager.currentlyEffective")}</Tag>
//               ) : (
//                 <Tag color="orange">{t("priceManager.pricePending")}</Tag>
//               )}
//             </Space>
//           </div>
//         </div>

//         {/* Price Statistics Cards */}
//         <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
//           <Col xs={24} sm={8}>
//             <Card
//               size="small"
//               bordered={false}
//               style={{ backgroundColor: "#f5f5f5" }}
//             >
//               <Statistic
//                 title={t("priceManager.basePrice")}
//                 value={formatCurrency(
//                   packageData.base_price,
//                   packageData.currency,
//                 )}
//                 valueStyle={{ color: "#1890ff", fontSize: "20px" }}
//                 prefix={
//                   currencySymbol === "€" ? <EuroOutlined /> : <DollarOutlined />
//                 }
//               />
//             </Card>
//           </Col>
//           {packageData.discounted_price && (
//             <Col xs={24} sm={8}>
//               <Card
//                 size="small"
//                 bordered={false}
//                 style={{ backgroundColor: "#f6ffed" }}
//               >
//                 <Statistic
//                   title={t("priceManager.discountedPrice")}
//                   value={formatCurrency(
//                     packageData.discounted_price,
//                     packageData.currency,
//                   )}
//                   valueStyle={{ color: "#52c41a", fontSize: "20px" }}
//                   prefix={
//                     currencySymbol === "€" ? (
//                       <EuroOutlined />
//                     ) : (
//                       <DollarOutlined />
//                     )
//                   }
//                 />
//                 {discountPercentage && (
//                   <div style={{ marginTop: "8px" }}>
//                     <Tag color="green" icon={<PercentageOutlined />}>
//                       {discountPercentage}% {t("priceManager.off")}
//                     </Tag>
//                   </div>
//                 )}
//               </Card>
//             </Col>
//           )}
//           <Col xs={24} sm={packageData.discounted_price ? 8 : 16}>
//             <Card
//               size="small"
//               bordered={false}
//               style={{ backgroundColor: "#e6f7ff" }}
//             >
//               <Statistic
//                 title={t("priceManager.currentPrice")}
//                 value={formatCurrency(
//                   packageData.discounted_price || packageData.base_price,
//                   packageData.currency,
//                 )}
//                 valueStyle={{
//                   color: "#1890ff",
//                   fontSize: "24px",
//                   fontWeight: "bold",
//                 }}
//                 prefix={
//                   currencySymbol === "€" ? <EuroOutlined /> : <DollarOutlined />
//                 }
//               />
//             </Card>
//           </Col>
//         </Row>

//         {/* Package Details in Descriptions */}
//         <Descriptions bordered column={2}>
//           <Descriptions.Item label={t("priceManager.packageName")} span={2}>
//             <Space>
//               <TagOutlined />
//               {packageData.name}
//             </Space>
//           </Descriptions.Item>

//           <Descriptions.Item label={t("priceManager.packageType")} span={1}>
//             <Tag color={packageTypeInfo.color}>{packageTypeInfo.label}</Tag>
//           </Descriptions.Item>

//           <Descriptions.Item label={t("priceManager.duration")} span={1}>
//             {getDurationLabel(packageData.duration)}
//           </Descriptions.Item>

//           <Descriptions.Item label={t("priceManager.packageId")} span={1}>
//             {packageData.id}
//           </Descriptions.Item>

//           <Descriptions.Item label={t("priceManager.currency")} span={1}>
//             {packageData.currency} ({currencySymbol})
//           </Descriptions.Item>

//           <Descriptions.Item label={t("priceManager.basePrice")} span={1}>
//             <Text strong>
//               {formatCurrency(packageData.base_price, packageData.currency)}
//             </Text>
//           </Descriptions.Item>

//           {packageData.discounted_price && (
//             <Descriptions.Item
//               label={t("priceManager.discountedPrice")}
//               span={1}
//             >
//               <Text type="success" strong>
//                 {formatCurrency(
//                   packageData.discounted_price,
//                   packageData.currency,
//                 )}
//               </Text>
//               {discountPercentage && (
//                 <Tag color="green" style={{ marginLeft: "8px" }}>
//                   {discountPercentage}% {t("priceManager.off")}
//                 </Tag>
//               )}
//             </Descriptions.Item>
//           )}

//           <Descriptions.Item
//             label={t("priceManager.subscriptionDates")}
//             span={2}
//           >
//             {packageData.effective_start || packageData.effective_end ? (
//               <Space direction="vertical" size="small">
//                 {packageData.effective_start && (
//                   <Space>
//                     <CalendarOutlined />
//                     <strong>{t("priceManager.from")}:</strong>{" "}
//                     {formatDate(packageData.effective_start)}
//                   </Space>
//                 )}
//                 {packageData.effective_end && (
//                   <Space>
//                     <CalendarOutlined />
//                     <strong>{t("priceManager.to")}:</strong>{" "}
//                     {formatDate(packageData.effective_end)}
//                   </Space>
//                 )}
//                 {!packageData.effective_start && !packageData.effective_end && (
//                   <Text type="secondary">
//                     {t("priceManager.alwaysEffective")}
//                   </Text>
//                 )}
//               </Space>
//             ) : (
//               <Text type="secondary">{t("priceManager.alwaysEffective")}</Text>
//             )}
//           </Descriptions.Item>

//           <Descriptions.Item label={t("common.createdAt")} span={1}>
//             <Space>
//               <CalendarOutlined />
//               {formatDate(packageData.created_at)}
//             </Space>
//           </Descriptions.Item>

//           <Descriptions.Item label={t("common.lastUpdated")} span={1}>
//             <Space>
//               <ClockCircleOutlined />
//               {formatDate(packageData.updated_at)}
//             </Space>
//           </Descriptions.Item>

//           <Descriptions.Item label={t("common.status")} span={1}>
//             <Tag color={packageData.is_active ? "green" : "default"}>
//               {packageData.is_active
//                 ? t("common.active")
//                 : t("common.inactive")}
//             </Tag>
//           </Descriptions.Item>

//           <Descriptions.Item label={t("priceManager.priceStatus")} span={1}>
//             {effective ? (
//               <Tag color="green" icon={<CheckCircleOutlined />}>
//                 {t("priceManager.currentlyEffective")}
//               </Tag>
//             ) : (
//               <Tag color="orange" icon={<CloseCircleOutlined />}>
//                 {t("priceManager.pendingExpired")}
//               </Tag>
//             )}
//           </Descriptions.Item>
//         </Descriptions>
//       </Card>
//     </div>
//   );
// };

// export default SubscriptionPriceDetails;

import React, { useState, useEffect } from "react";
import {
  Card,
  Descriptions,
  Tag,
  Button,
  Space,
  Typography,
  Divider,
  Statistic,
  Row,
  Col,
  Table,
  Tooltip,
} from "antd";
import {
  ArrowLeftOutlined,
  EditOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  TagOutlined,
  EuroOutlined,
  DollarOutlined,
  PercentageOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useDynamicApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../config/api";
import Toast from "../../utils/toast";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

const SubscriptionPriceDetails = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);

  // API hooks
  const { execute: getPackage, loading: packageLoading } = useDynamicApi("GET");

  // Options as per FRS and your model
  const PACKAGE_TYPE_OPTIONS = [
    {
      value: "INDIVIDUAL",
      label: t("priceManager.packageTypeIndividual"),
      color: "blue",
    },
    { value: "CLUB", label: t("priceManager.packageTypeClub"), color: "green" },
    {
      value: "KNKV",
      label: t("priceManager.packageTypeKNKV"),
      color: "purple",
    },
  ];

  const DURATION_OPTIONS = [
    { value: "MONTHLY", label: t("priceManager.durationMonthly") },
    { value: "QUARTERLY", label: t("priceManager.durationQuarterly") },
    { value: "YEARLY", label: t("priceManager.durationYearly") },
    { value: "SEASONAL", label: t("priceManager.durationSeasonal") },
  ];

  const CURRENCY_SYMBOLS = {
    EUR: "€",
    USD: "$",
    INR: "₹",
  };

  // Load package details
  const loadPackageDetails = async () => {
    setLoading(true);
    try {
      const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${id}`;
      const response = await getPackage(endpoint);

      if (response?.status === true && response.data) {
        setPackageData(response.data);
      } else {
        Toast.error(t("priceManager.failedFetchDetails"));
        navigate("/subscriptionprice");
      }
    } catch (error) {
      console.error("Error fetching package details:", error);
      Toast.error(error.message || t("priceManager.failedFetchDetails"));
      navigate("/subscriptionprice");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      loadPackageDetails();
    }
  }, [id]);

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Format currency
  const formatCurrency = (amount, currency) => {
    if (!amount || isNaN(amount)) return "N/A";
    const symbol = CURRENCY_SYMBOLS[currency] || currency;
    return `${symbol}${parseFloat(amount).toFixed(2)}`;
  };

  // Get package type info
  const getPackageTypeInfo = (type) => {
    const found = PACKAGE_TYPE_OPTIONS.find((opt) => opt.value === type);
    return found || { label: type, color: "default" };
  };

  // Get duration label
  const getDurationLabel = (duration) => {
    const option = DURATION_OPTIONS.find((opt) => opt.value === duration);
    return option ? option.label : duration;
  };

  // Check if price is effective
  const isPriceEffective = (item) => {
    if (!item?.effective_start && !item?.effective_end) {
      return true;
    }
    const today = new Date();
    const startDate = item.effective_start
      ? new Date(item.effective_start)
      : null;
    const endDate = item.effective_end ? new Date(item.effective_end) : null;
    if (startDate && today < startDate) return false;
    if (endDate && today > endDate) return false;
    return true;
  };

  // Calculate discount percentage
  const getDiscountPercentage = () => {
    if (!packageData?.discounted_price || !packageData?.base_price) return null;
    const base = parseFloat(packageData.base_price);
    const discounted = parseFloat(packageData.discounted_price);
    if (base <= 0) return null;
    const discount = ((base - discounted) / base) * 100;
    return Math.round(discount);
  };

  // Seasonal prices table columns
  const seasonalColumns = [
    {
      title: t("priceManager.startMonth"),
      dataIndex: "start_month",
      key: "start_month",
      render: (month) => {
        const monthNames =
          i18n.language === "nl"
            ? [
                "Jan",
                "Feb",
                "Maa",
                "Apr",
                "Mei",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dec",
              ]
            : [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ];
        return month ? `${month} (${monthNames[month - 1]})` : "-";
      },
    },
    {
      title: t("priceManager.endMonth"),
      dataIndex: "end_month",
      key: "end_month",
      render: (month) => {
        const monthNames =
          i18n.language === "nl"
            ? [
                "Jan",
                "Feb",
                "Maa",
                "Apr",
                "Mei",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dec",
              ]
            : [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ];
        return month ? `${month} (${monthNames[month - 1]})` : "-";
      },
    },
    {
      title: t("priceManager.price"),
      dataIndex: "price",
      key: "price",
      render: (price) => formatCurrency(price, packageData?.currency),
    },
    {
      title: t("common.status"),
      dataIndex: "is_active",
      key: "is_active",
      render: (active) => (
        <Tag color={active ? "green" : "default"}>
          {active ? t("common.active") : t("common.inactive")}
        </Tag>
      ),
    },
  ];

  if (loading || packageLoading) return null;

  if (!packageData) {
    return (
      <Card>
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Title level={3}>{t("priceManager.noPricesFound")}</Title>
          <Button type="primary" onClick={() => navigate("/subscriptionprice")}>
            {t("common.previous")} {t("priceManager.packages")}
          </Button>
        </div>
      </Card>
    );
  }

  const packageTypeInfo = getPackageTypeInfo(packageData.package_type);
  const discountPercentage = getDiscountPercentage();
  const effective = isPriceEffective(packageData);
  const currencySymbol =
    CURRENCY_SYMBOLS[packageData.currency] || packageData.currency;
  const hasSeasonalPrices =
    packageData.duration === "SEASONAL" &&
    packageData.seasonal_prices &&
    packageData.seasonal_prices.length > 0;

  return (
    <div className="package-details-page">
      {/* Header with back button and actions */}
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Space>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/subscriptionprice")}
          >
            {t("common.previous")} {t("priceManager.packages")}
          </Button>
          <Title level={4} style={{ margin: 0 }}>
            {t("priceManager.details")}
          </Title>
        </Space>
      </div>

      {/* Main Content */}
      <Card>
        {/* Avatar and Title Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <div>
            <h1 style={{ margin: 0, marginBottom: "8px" }}>
              {packageData.name}
            </h1>
            <Space size="middle" wrap>
              <Tag color={packageTypeInfo.color}>{packageTypeInfo.label}</Tag>
              <Tag color={packageData.is_active ? "green" : "default"}>
                {packageData.is_active
                  ? t("common.active")
                  : t("common.inactive")}
              </Tag>
              {effective ? (
                <Tag color="green">{t("priceManager.currentlyEffective")}</Tag>
              ) : (
                <Tag color="orange">{t("priceManager.pricePending")}</Tag>
              )}
            </Space>
          </div>
        </div>

        {/* Price Statistics Cards */}
        <Row gutter={[16, 16]} style={{ marginBottom: "24px" }}>
          <Col xs={24} sm={8}>
            <Card
              size="small"
              bordered={false}
              style={{ backgroundColor: "#f5f5f5" }}
            >
              <Statistic
                title={t("priceManager.basePrice")}
                value={formatCurrency(
                  packageData.base_price,
                  packageData.currency,
                )}
                valueStyle={{ color: "#1890ff", fontSize: "20px" }}
                prefix={
                  currencySymbol === "€" ? <EuroOutlined /> : <DollarOutlined />
                }
              />
            </Card>
          </Col>
          {packageData.discounted_price && (
            <Col xs={24} sm={8}>
              <Card
                size="small"
                bordered={false}
                style={{ backgroundColor: "#f6ffed" }}
              >
                <Statistic
                  title={t("priceManager.discountedPrice")}
                  value={formatCurrency(
                    packageData.discounted_price,
                    packageData.currency,
                  )}
                  valueStyle={{ color: "#52c41a", fontSize: "20px" }}
                  prefix={
                    currencySymbol === "€" ? (
                      <EuroOutlined />
                    ) : (
                      <DollarOutlined />
                    )
                  }
                />
                {discountPercentage && (
                  <div style={{ marginTop: "8px" }}>
                    <Tag color="green" icon={<PercentageOutlined />}>
                      {discountPercentage}% {t("priceManager.off")}
                    </Tag>
                  </div>
                )}
              </Card>
            </Col>
          )}
          <Col xs={24} sm={packageData.discounted_price ? 8 : 16}>
            <Card
              size="small"
              bordered={false}
              style={{ backgroundColor: "#e6f7ff" }}
            >
              <Statistic
                title={t("priceManager.currentPrice")}
                value={formatCurrency(
                  packageData.discounted_price || packageData.base_price,
                  packageData.currency,
                )}
                valueStyle={{
                  color: "#1890ff",
                  fontSize: "24px",
                  fontWeight: "bold",
                }}
                prefix={
                  currencySymbol === "€" ? <EuroOutlined /> : <DollarOutlined />
                }
              />
            </Card>
          </Col>
        </Row>

        {/* Package Details in Descriptions */}
        <Descriptions bordered column={2}>
          <Descriptions.Item label={t("priceManager.packageName")} span={2}>
            <Space>
              <TagOutlined />
              {packageData.name}
            </Space>
          </Descriptions.Item>

          <Descriptions.Item label={t("priceManager.packageType")} span={1}>
            <Tag color={packageTypeInfo.color}>{packageTypeInfo.label}</Tag>
          </Descriptions.Item>

          <Descriptions.Item label={t("priceManager.duration")} span={1}>
            {getDurationLabel(packageData.duration)}
          </Descriptions.Item>

          <Descriptions.Item label={t("priceManager.packageId")} span={1}>
            {packageData.id}
          </Descriptions.Item>

          <Descriptions.Item label={t("priceManager.currency")} span={1}>
            {packageData.currency} ({currencySymbol})
          </Descriptions.Item>

          <Descriptions.Item label={t("priceManager.basePrice")} span={1}>
            <Text strong>
              {formatCurrency(packageData.base_price, packageData.currency)}
            </Text>
          </Descriptions.Item>

          {packageData.discounted_price && (
            <Descriptions.Item
              label={t("priceManager.discountedPrice")}
              span={1}
            >
              <Text type="success" strong>
                {formatCurrency(
                  packageData.discounted_price,
                  packageData.currency,
                )}
              </Text>
              {discountPercentage && (
                <Tag color="green" style={{ marginLeft: "8px" }}>
                  {discountPercentage}% {t("priceManager.off")}
                </Tag>
              )}
            </Descriptions.Item>
          )}

          {/* Coach Price - only for CLUB packages */}
          {packageData.package_type === "CLUB" && (
            <Descriptions.Item label={t("priceManager.coachPrice")} span={1}>
              <Text>
                {formatCurrency(packageData.coach_price, packageData.currency)}
              </Text>
              <Tooltip title={t("priceManager.coachPriceTooltip")}>
                <InfoCircleOutlined
                  style={{ marginLeft: "8px", color: "#888" }}
                />
              </Tooltip>
            </Descriptions.Item>
          )}

          <Descriptions.Item
            label={t("priceManager.subscriptionDates")}
            span={2}
          >
            {packageData.effective_start || packageData.effective_end ? (
              <Space direction="vertical" size="small">
                {packageData.effective_start && (
                  <Space>
                    <CalendarOutlined />
                    <strong>{t("priceManager.from")}:</strong>{" "}
                    {formatDate(packageData.effective_start)}
                  </Space>
                )}
                {packageData.effective_end && (
                  <Space>
                    <CalendarOutlined />
                    <strong>{t("priceManager.to")}:</strong>{" "}
                    {formatDate(packageData.effective_end)}
                  </Space>
                )}
                {!packageData.effective_start && !packageData.effective_end && (
                  <Text type="secondary">
                    {t("priceManager.alwaysEffective")}
                  </Text>
                )}
              </Space>
            ) : (
              <Text type="secondary">{t("priceManager.alwaysEffective")}</Text>
            )}
          </Descriptions.Item>

          <Descriptions.Item label={t("common.createdAt")} span={1}>
            <Space>
              <CalendarOutlined />
              {formatDate(packageData.created_at)}
            </Space>
          </Descriptions.Item>

          <Descriptions.Item label={t("common.lastUpdated")} span={1}>
            <Space>
              <ClockCircleOutlined />
              {formatDate(packageData.updated_at)}
            </Space>
          </Descriptions.Item>

          <Descriptions.Item label={t("common.status")} span={1}>
            <Tag color={packageData.is_active ? "green" : "default"}>
              {packageData.is_active
                ? t("common.active")
                : t("common.inactive")}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item label={t("priceManager.priceStatus")} span={1}>
            {effective ? (
              <Tag color="green" icon={<CheckCircleOutlined />}>
                {t("priceManager.currentlyEffective")}
              </Tag>
            ) : (
              <Tag color="orange" icon={<CloseCircleOutlined />}>
                {t("priceManager.pendingExpired")}
              </Tag>
            )}
          </Descriptions.Item>
        </Descriptions>

        {/* Seasonal Prices Section */}
        {hasSeasonalPrices && (
          <>
            <Divider orientation="left">
              <Space>
                <CalendarOutlined />
                {t("priceManager.seasonalPrices")}
              </Space>
            </Divider>
            <Table
              dataSource={packageData.seasonal_prices}
              columns={seasonalColumns}
              rowKey={(record, index) => index}
              pagination={false}
              size="middle"
              bordered
            />
            <div style={{ marginTop: "12px", fontSize: "12px", color: "#888" }}>
              {t("priceManager.seasonalPricesHint")}
            </div>
          </>
        )}
      </Card>
    </div>
  );
};

export default SubscriptionPriceDetails;
